/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Adjust_SearchInputs */

const en_common_adjust_search = /** @type {(inputs: Common_Adjust_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try adjusting your search terms`)
};

const es_common_adjust_search = /** @type {(inputs: Common_Adjust_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba cambiando la búsqueda`)
};

/**
* | output |
* | --- |
* | "Try adjusting your search terms" |
*
* @param {Common_Adjust_SearchInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_adjust_search = /** @type {((inputs?: Common_Adjust_SearchInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Adjust_SearchInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_adjust_search(inputs)
	return en_common_adjust_search(inputs)
});